<template>
  <div class="right-fix-wrapper">
    <div class="menu-icon"></div>
    <span class="menu-title">{{currentMunu.title}}</span>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters(['currentMunu'])
  },
}
</script>

<style lang="less">
.right-fix-wrapper {
  width: 100%;
  height: 50px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding-left: 20px;
  box-shadow: 0 1px 4px rgba(0,21,41,.2);
}
.menu-icon {
  width: 20px;
  height: 20px;
  background: url('../assets/images/menu.png') center/100% no-repeat;
  margin-right: 20px;
}
.menu-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}
</style>


// WEBPACK FOOTER //
// src/components/RightFix.vue